/**
 * Normalizes pasted / rich-text HTML from the CMS at render time (no DB changes).
 * Reduces invalid nesting (e.g. <p> inside <p>/<h1>) and hydration mismatches.
 */

function stripOneOuterParagraphLayer(html: string): string {
  const t = html.trim();
  const openMatch = /^<p(\s[^>]*)?>/i.exec(t);
  if (!openMatch || openMatch.index !== 0) return html;

  let depth = 1;
  let pos = openMatch[0].length;

  while (pos < t.length) {
    const rest = t.slice(pos);
    const nextOpen = /<p(\s[^>]*)?>/i.exec(rest);
    const nextClose = /<\/p>/i.exec(rest);
    const openPos = nextOpen?.index ?? Infinity;
    const closePos = nextClose?.index ?? Infinity;

    if (openPos === Infinity && closePos === Infinity) break;

    if (openPos < closePos) {
      depth++;
      pos += openPos + nextOpen![0].length;
    } else {
      depth--;
      if (depth === 0) {
        return t.slice(openMatch[0].length, pos + closePos).trim();
      }
      pos += closePos + nextClose![0].length;
    }
  }
  return html;
}

export function normalizeCmsHtml(raw: string | null | undefined): string {
  if (raw == null || typeof raw !== "string") return "";
  let s = raw.trim();
  if (!s) return "";

  s = s.replace(/<\/?html[^>]*>/gi, "");
  s = s.replace(/<head\b[^>]*>[\s\S]*?<\/head>/gi, "");
  s = s.replace(/<\/?body[^>]*>/gi, "");
  
  // remove the nofollow ref from the attribute
  s = s.replace(/nofollow"/gi, '"');

  for (let d = 0; d < 8; d++) {
    const next = stripOneOuterParagraphLayer(s);
    if (next === s) break;
    s = next;
  }

  return s.trim();
}
